<div class="container-fluid p-2">

    <div class="row">
        <div class="col-md-4">
                <div class="dash-tile dash-tile-excellent clearfix">
                    <div class="dash-tile-header">{{'number_of_team' | translate}}</div>
                    <div class="dash-tile-icon">
                        <i class="far fa-building"></i>
                    </div>
                    <div class="dash-tile-text">
                        {{organization?.activeTeamsCount}}/{{organization?.teams.length}}
                    </div>
                </div>
        </div>
        <div class="col-md-4">
                <div class="dash-tile dash-tile-good clearfix">
                    <div class="dash-tile-header">{{'number_of_people' | translate}}</div>
                    <div class="dash-tile-icon">
                        <i class="far fa-users"></i>
                    </div>
                    <div class="dash-tile-text" [ngStyle]="max_capacity_reached && {'color':'red'}">
                        {{organization?.activeMembersCount}}
                    </div>
                </div>
        </div>
        <div class="col-md-4">
                @if(organization?.maxUsers){
                    <div class="dash-tile dash-tile-average clearfix">
                        <div class="dash-tile-header">{{'capacity' | translate}}</div>
                        <div class="dash-tile-icon">
                            <i class="far fa-lock"></i>
                        </div>
                        <div class="dash-tile-text" [ngStyle]="max_capacity_reached && {'color':'red'}">
                            {{organization.maxUsers}}
                        </div>
                    </div>
                }
            </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="d-flex justify-content-between mb-3">
                <h3 class="page-header">
                    {{organization?.name}} - {{'team_list' | translate}}
                </h3>
                <div class="">
                    <button [routerLink]="['/admin/organization', $safeNavigationMigration(organization?.id), 'settings']" class="btn btn-default"><i
                            class="far fa-cog"></i> {{'org_settings' | translate}}</button>
                    <button [routerLink]="['/admin/organization', $safeNavigationMigration(organization?.id), 'team', 'new']" class="btn btn-primary"><i class="far fa-plus"></i> {{'create_team' | translate}}</button>
                </div>
            </div>

            <table class="table table-hover">
                <tbody>
                @for(team of organization?.teams;track team.id){
                <tr [ngStyle]="!team.active && {'opacity':'0.4'}">
                    <td>
                        {{team.name}}
                    </td>
                    <td>
                        <small>{{team.id}}</small>
                    </td>
                    <td>
                        <i class="far fa-user"></i> {{team.membersCount}}
                    </td>
                    <td>
                        <a [routerLink]="['/admin/team', team.id]" target="_blank"><i class="fas fa-lock"></i>
                            Admin</a>
                    </td>
                    <td>
                        <a [routerLink]="['/home', team.id]" target="_blank"><i class="far fa-timeline"></i>
                            {{'home' | translate}}</a>
                    </td>
                    <td>
                    <td>
                        <a [routerLink]="['/setup/teammembers', team.id]" target="_blank"><i class="far fa-cog"></i>
                            {{'team_management' | translate}}</a>
                    </td>
                    <td>
                        <a [routerLink]="['/calendar', team.id]" target="_blank"><i class="far fa-calendar"></i> {{'calendar' |
                        translate}}</a>
                    </td>
                </tr>
                }
                </tbody>

            </table>
        </div>
    </div>

</div>